import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./style.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { store } from "./store/store";
import { Provider } from "react-redux";
import "bootstrap/dist/css/bootstrap.min.css";
import Toast from '../src/components/toaster/Toaster';
import { PersistGate } from 'redux-persist/integration/react';
import { persistStore } from 'redux-persist'
// import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';

// // Register all Community features
// ModuleRegistry.registerModules([AllCommunityModule]);
// import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community'; 
import { ModuleRegistry } from 'ag-grid-community'; 
import { AllEnterpriseModule } from 'ag-grid-enterprise';

// Register all Community features
// ModuleRegistry.registerModules([AllCommunityModule]);
ModuleRegistry.registerModules([AllEnterpriseModule]);


const root = ReactDOM.createRoot(document.getElementById("root"));
let persistor = persistStore(store);
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor} >
      <Toast />
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </PersistGate>
  </Provider>
);

reportWebVitals();
